import React from 'react';
import {useSelector} from "react-redux";

import css from './PriceTableComponent.module.css';
import PriceTableSingleComponent from "../PriceTableSingleComponent/PriceTableSingleComponent";


const PriceTableComponent = () => {
    const {packs} = useSelector(store => store.packs);


    return (
        <div className={css.wrap}>
            <div className={css.header}>
                <div>1 d</div>
                <div>2 d</div>
                <div>4 d</div>
                <div>5 d</div>
                <div>7 d</div>
                <div>14 d</div>
                <div>20 d</div>
                <div>30 d</div>
            </div>

            <div className={css.container}>
                {packs.length > 0 && packs
                    .map(obj => <PriceTableSingleComponent
                        key={obj.id}
                        pack={obj}/>)
                }
            </div>
        </div>
    );
};

export default React.memo(PriceTableComponent);